module.exports = __webpack_public_path__ + "img/angle-left-solid.646958b7.svg";